import styled, { css } from 'styled-components'
import colorsOptions from '../../components/stories/fundamentals/colors-styles/constants'
import { HeaderContainer as TableHeaderContainer } from '../../components/stories/organisms/table/components/header/styled-components'
import { ToolbarContainer } from '../../components/stories/organisms/table/components/toolbar/styled-components'
import {
  TableStyled,
  TableWrapper
} from '../../components/stories/organisms/table/styled-components'
import {
  textStyleWeightOptions,
  textStyleWeightStyleOptions,
  textStyleSizeOptions,
  textStyleSizeStyleOptions
} from '../../components/stories/fundamentals/text-styles/constants'

// General Modals
export const ModalBody = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
`

export const ModalContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colorsOptions.greys.white};
  border-radius: 16px;
  padding: 1.5rem;
`

export const TransparentModalContentContainer = styled(ModalContentContainer)`
  padding: 0 1.5rem 0.5rem;
  background-color: transparent;
`

export const SectionTitle = styled.div`
  color: ${colorsOptions.greys['grey-90']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]}
  padding: 1rem 1rem 0.5rem 0;
`

export const ProjectMenuContainer = styled.div`
  padding: 2.5rem 1rem 0 1rem;
  height: 100%;
`

export const LoadingNextPage = styled.div`
  padding-bottom: 2rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

// Header

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 2rem;
`

export const Title = styled.p`
  color: ${colorsOptions.greys.black};
  font-variant-numeric: lining-nums proportional-nums;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XXXL']]}
  line-height: 41.6px;
  letter-spacing: 0.2px;
`

export const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`

export const ButtonChildrenContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`

export const ButtonOnlyIconContainer = styled(ButtonChildrenContainer)`
  gap: 0.25rem;
`

export const ProjectListTypeButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

// Create project modal

export const FormContainer = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const MembershipContainer = styled.div`
  padding-top: 2rem;
`

// Move items modal

export const TotalItemsToMove = styled.div`
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
`

// Project Table

export const ProjectMenuTableContainer = styled.div`
  width: 100%;
  background-color: ${colorsOptions.greys.white};
  border: 1px solid ${colorsOptions.greys['grey-20']};
  border-radius: 0 16px 16px 16px;
  overflow: visible;

  ${ToolbarContainer} {
    padding: 0.5rem 0.25rem 0.5rem 1rem;
    border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  }

  ${TableWrapper} {
    gap: 0;
  }

  ${TableStyled} {
    border: 0;
    border-radius: 0;
  }

  ${TableHeaderContainer} {
    &:first-child {
      border-top-left-radius: 0;
    }

    &:last-child {
      border-top-right-radius: 0;
    }
  }
`

export const ProjectMenuTableStatusContent = styled.div`
  min-height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colorsOptions.greys['grey-60']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
`

export const ShowInactiveProjectContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  min-width: 250px;
`

export const ShowInactiveProjectLabel = styled.span`
  font-variant-numeric: lining-nums proportional-nums;
  color: ${colorsOptions.greys['grey-40']};

  /* 600 (semibold)/600-R */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  line-height: 18.2px; /* 130% */
  letter-spacing: 0.2px;

  &[data-checked='true'] {
    color: ${colorsOptions.greys['grey-100']};
  }
`

export const ProjectMenuHeaderContainer = styled.div`
  display: flex;
  align-items: center;
`

export const ProjectMenuHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
`

export const ProjectMenuHeaderRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`

export const ProjectMenuHeaderSelected = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const ProjectMenuHeaderButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const TableProjectsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`

export const ProjectMenuTableScrollContainer = styled.div`
  overflow-x: auto;
`

export const TableProjectsPaginationContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 48px;
  padding: 0.5rem;
`

// Project Menu Tile

export const ProjectMenuTileListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  min-height: 300px;
  padding: 0.5rem 0 2.5rem;
`

export const TileBackFolderCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 255px;
  min-height: 300px;
  height: 100%;
  padding: 1rem;
  border-radius: 16px;
  background-color: ${colorsOptions.greys.white};
  border: 1px solid ${colorsOptions.greys['grey-20']};
  flex: 0 0 auto;
  cursor: pointer;
  z-index: 2;

  &:hover {
    background-color: ${colorsOptions.greys['grey-05']};
  }

  &:active {
    background-color: ${colorsOptions.greys['grey-10']};
  }
`

export const TileToolbarContainer = styled.div`
  padding: 0.5rem 0.25rem 0rem 1rem;
`

export const NotFoundContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5rem 2.5rem 2rem;
`

export const EmptyProjectTreeContainer = styled(NotFoundContainer)`
  position: absolute;
  width: 100%;
  z-index: 1;
`

export const EmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 432px;
  gap: 2rem;
`

export const EmptyProjectTreeButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`

// Context Menu
export const ContextMenuTitle = styled.div`
  display: flex;
  padding: 1rem 1rem 0.5rem 1rem;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  color: ${colorsOptions.greys['grey-70']};
  text-transform: uppercase;
`

export const NotFoundContainerBody = styled.tbody`
  background-color: ${colorsOptions.greys['grey-10']};
`

export const NotFoundContainerRow = styled.tr`
  background-color: ${colorsOptions.greys['grey-10']};
`

export const NotFoundContainerCell = styled.td`
  width: 100%;
  height: 460px;
  padding: 1rem 2.5rem 2rem;
  vertical-align: middle;
  border-top: 1px solid ${colorsOptions.greys['grey-20']};
  background-color: ${colorsOptions.greys['grey-10']};
`

export const NotFoundContainerContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`

// Mobile view

export const MobileViewContainer = styled.div`
  background-color: ${colorsOptions.greys['grey-10']};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 2.5rem 1rem 2rem;
`

export const MobileListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 5rem;
  gap: 0.5rem;
`

export const MobileViewHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  padding: 0rem 0rem 1rem;
`

export const HeaderTitle = styled.div`
  position: sticky;
  top: -2.5rem;
  z-index: 10;
  display: flex;
  align-items: center;

  transition:
    font-size 0.25s ease,
    line-height 0.25s ease;

  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  color: ${colorsOptions.greys.black};
  background-color: ${colorsOptions.greys['grey-10']};

  ${({ $isSticky }) =>
    $isSticky
      ? css`
          ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]}
          justify-content: center;
          padding: 0.5rem 0;
        `
      : css`
          ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XXXL']]}
          justify-content: flex-start;
        `}
`

export const HeaderSearchContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const NotFoundContainerMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2.5rem;
`
